import FontAwesome from 'react-fontawesome'
import React from 'react'

class Cornelius extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-content">
          <div className="content is-medium">
            <div className="columns">
              <div className="column is-two-thirds">
                <center>
                  <img className="team-image cornelius-image" src="/images/cornelius.jpg" role="presentation" />
                  <h3 className="title is-3">Cornelius</h3>
                  <h4 className="subtitle">Chief Barking Officer</h4>
                </center>
              </div>
              <div className="column team-column-links">
                <p>
                  <a href="mailto:cornelius@burnest.com">
                    <FontAwesome className="team-link-logo" name="envelope-open" /> cornelius@burznest.com
                  </a>
                </p>
                <p>
                  <a href="https://www.instagram.com/cornyscorners" target="_blank">
                    <FontAwesome className="team-link-logo" name="instagram" /> @cornyscorners
                  </a>
                </p>
                <p>
                  <a href="https://www.instagram.com/big_city_shibe" target="_blank">
                    <FontAwesome className="team-link-logo" name="instagram" /> @big_city_shibe
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Cornelius



// WEBPACK FOOTER //
// ./src/Cornelius.js